// Bridge to the global i18n scripts loaded in index.html.
//
// The translator (window.i18nTranslator) walks the live DOM and rewrites the
// innerHTML of [data-i18n] elements in place. React tolerates that as long as
// it never re-renders those nodes with different children — see components/T.jsx.
// These helpers exist so no component reaches for the globals directly, and so
// every call site degrades quietly when the scripts failed to load.

export function config() {
  return window.i18nConfig || null;
}

export function currentLang() {
  const c = config();
  return (c && c.currentLang) || 'en';
}

export function displayMode() {
  const c = config();
  return (c && c.displayMode) || 'auto';
}

export function setLanguage(lang) {
  const c = config();
  if (c) c.setLanguage(lang);
}

export function setDisplayMode(mode) {
  const c = config();
  if (c) c.setDisplayMode(mode);
}

export function isRTL() {
  const c = config();
  return !!(c && c.isRTL);
}

// After a language change: drop every translation currently on the page and
// start over. resetTranslations() restores the stored English innerHTML, so the
// DOM lands back where React believes it is before the next pass runs.
export function retranslateAll() {
  const t = window.i18nTranslator;
  if (!t) return;
  t.resetTranslations();
  t.init();
}

// After a display-mode change: the text stays as it is, only the listeners
// (auto vs. hover) are rebuilt.
export function reattachListeners() {
  const t = window.i18nTranslator;
  if (!t) return;
  t.resetTranslations();
  t.initTranslationListeners();
}

// Re-scan for [data-i18n] nodes React has just mounted. The translator's own
// MutationObserver also catches these; calling it explicitly removes the
// dependence on observer timing for content we know we just rendered.
export function registerNewNodes() {
  if (window.i18nUtils) window.i18nUtils.buildHashRegistry();
  if (window.i18nTranslator) window.i18nTranslator.initTranslationListeners();
}
